import React, { useState } from 'react';

import LoginHeader from '../../Login/LoginHeader';
import styles from './CommonLayout.module.scss';

function CommonLayout(props) {
  const { children } = props;
  const [zoomLevel, setZoomLevel] = useState(Math.round(window.devicePixelRatio * 100));

  window.addEventListener('resize', () => {
    const browserZoomLevel = Math.round(window.devicePixelRatio * 100);
    setZoomLevel(browserZoomLevel);
  });

  const getClassName = () => {
    if (zoomLevel >= 50) {
      return styles.footerDivHeight25;
    } else {
      return styles.footerDivHeight80;
    }
  };

  const getFooterContentZoomAdjustmentStyle = () => {
    if (zoomLevel <= 25) {
      return styles.footerContent25;
    }
    if (zoomLevel === 33) {
      return styles.footerContent33;
    }
  };

  const loginFooter = () => {
    return (
      <div className={styles.footer}>
        <div className={`${styles.footerContent} ${getFooterContentZoomAdjustmentStyle()}`}>
          <div className={styles.footerContentMail}>
            <p>bgv-india@springrole.com</p>
          </div>
          <p>080-471-07765</p>
          <div className={styles.footerContentAddress}>
            <p>No.19, 2nd Floor, Amar Plaza,</p> <p>Krishnanagar Industrial Layout Hosur Rd,</p>{' '}
            <p>Bengaluru, Karnataka, 560029</p>
            <a href={'https://in.springverify.com/privacy-policy/'} target={'_blank'}>
              <p>Privacy Policy</p>
            </a>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className={styles.headerDiv}>
        <LoginHeader />
      </div>
      <div className={styles.middleDiv}>{children}</div>
      <div className={`${styles.footerDiv} ${getClassName()}`}>{loginFooter()}</div>
    </>
  );
}

export default CommonLayout;
